module.exports = __webpack_public_path__ + "img/profile-2.2ba3ad6c.png";